export let SliderType = /*#__PURE__*/function (SliderType) {
  SliderType["LessThan"] = "LessThan";
  SliderType["GreaterThan"] = "GreaterThan";
  SliderType["Equal"] = "Equal";
  return SliderType;
}({});
export let RangeSliderType = /*#__PURE__*/function (RangeSliderType) {
  RangeSliderType["Inclusive"] = "Inclusive";
  RangeSliderType["Exclusive"] = "Exclusive";
  return RangeSliderType;
}({});
export let GripType = /*#__PURE__*/function (GripType) {
  GripType["Minimum"] = "min";
  GripType["Maximum"] = "max";
  GripType["Single"] = "single";
  return GripType;
}({});
//# sourceMappingURL=SliderValues.js.map